import { getIdFromGraphQLId } from '~/graphql_shared/utils';
export default {
    name: 'NoteAuthor',
    props: {
        author: {
            type: Object,
            required: true
        },
        showUsername: {
            type: Boolean,
            required: false,
            default: true
        },
        truncate: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        authorId () {
            return getIdFromGraphQLId(this.author.id);
        }
    }
};
